/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { Component } from "react";
import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import styled from "styled-components";
import PropTypes from "prop-types";
import * as _ from "underscore";
import * as selectors from "../../selectors";
import * as walletAction from "../../actions/wallet";
import * as orderSelectors from "../../selectors/order";
import LoadingIndicator from "../../components/LoadingIndicator";
import Constant from "../../constants";
import IpayHelper from "../../utils/IpayHelper";
import Toast from "../../utils/Toast";
import Theme from "../../utils/Theme";
import "./index.css";
import * as variantSelectors from "../../selectors/variant";

const StyledContainer = styled.div`
  position: relative;
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledMainContainer = styled.div`
  position: absolute;
  height: auto;
  flex: 1;
  width: 90%;
  padding: 25px 0px 15px 0px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledSelectTopUpValueTitle = styled.div`
  color: #000;
  font-weight: bold;
  font-size: 1em;
  text-align: left;
  padding-bottom: 5px;
`;

const StyledSelectTopUpValueSpan = styled.div`
  color: grey;
  font-size: 1em;
  margin-bottom: 25px;
  text-align: left;
`;

const StyledSelectTopUpContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
`;

const StyledSelectTopUpValueItem = styled.div`
  width: 37%;
  border: 1px solid lightgray;
  font-size: 1.3em;
  color: black;
  padding: 15px;
  margin-bottom: 10px;
`;

const StyledTopUpSummaryContainer = styled.div`
  align-self: stretch;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  color: black;
  font-size: 0.9em;
`;

const StyledTopUpMethodTwo = styled.div`
  color: #000;
  font-size: 1em;
  font-weight: bold;
`;

const StyledTopUpMethodTwoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 25px;
`;

const StyledMethodTwoDescription = styled.div`
  color: grey;
  text-align: start;
  display: block;
  display: -webkit-box;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  font-size: 1em;
  line-height: 1.2;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 25px;
`;

const StyledTopUpBtn = styled.div`
  border-radius: 25px;
  width: 100%;
  color: white;
  background: ${props => (props.disabled ? "lightgray" : Theme.PrimaryColor)};
  text-transform: uppercase;
  display: flex;
  justify-content: center;

  align-items: center;
  vertical-align: bottom;
  padding: 15px 0;
  bottom: 0;
  margin-bottom: 25px;
  margin-top: 25px;
`;

const StyledQrCode = styled.div`
  border-radius: 25px;
  width: 100%;
  color: white;
  background: ${Theme.PrimaryColor};
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: bottom;
  padding: 15px 0;
  bottom: 0;
  margin-bottom: 15px;
`;
const StyledLine = styled.hr`
  border-top: 1px solid #000;
  width: 100%;
`;

class TopUpWalletPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animationClass: null,
      selectedPrice: null
    };
  }

  componentDidMount() {
    const { navbarConfig, showTabbar, showNavbar } = this.props;

    navbarConfig(
      <FormattedMessage
        id="topup.wallet.title"
        defaultMessage="Top Up my e-Wallet"
        description="Top Up Wallet Title"
      />,
      null,
      null,
      () => this.onBackPressed(),
      null
    );
    showNavbar(true);
    showTabbar(false);
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.topUpStatus !== nextProps.topUpStatus) {
      if (nextProps.topUpStatus && nextProps.topUpCreatePaymentItem) {
        const paymentObject = orderSelectors.getOrderPaymentObject(
          nextProps.topUpCreatePaymentItem
        );
        const paymentGatewayCode = orderSelectors.getOrderPaymentGatewayCode(
          paymentObject
        );

        if (paymentGatewayCode === Constant.iPay88) {
          this.startIPay88(paymentObject);
        }
      }
    }

    if (
      this.props.updateTopUpPaymentStatus !== nextProps.updateTopUpPaymentStatus
    ) {
      if (nextProps.updateTopUpPaymentStatus) {
        this.refreshWalletDetailData();
        this.props.history.goBack();
      }
    }
  }

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  getLoadingIndicator = () => {
    const { topUploading } = this.props;

    if (topUploading) {
      return <LoadingIndicator />;
    }

    return null;
  };

  onValueItemClicked = selectedId => {
    this.setState({ selectedPrice: selectedId });
  };

  refreshWalletDetailData = () => {
    const { refreshWalletDetailCache } = this.props;
    refreshWalletDetailCache && refreshWalletDetailCache();
  };

  isValid = () => {
    const { selectedPrice } = this.state;

    return selectedPrice !== null;
  };

  startIPay88 = topUpCreatePaymentItem => {
    const orderCurrentPaymentData = orderSelectors.getOrderPaymentData(
      topUpCreatePaymentItem
    );

    if (_.isEmpty(orderCurrentPaymentData)) {
      Toast.error(intl.formatMessage({ id: "app.not.available" }));
      return;
    }

    IpayHelper.checkout(orderCurrentPaymentData);
  };

  onPressTopUp = () => {
    const { selectedPrice, topupValueOptions } = this.state;
    const { createTopUpRequest, getTopUpItemData } = this.props;

    const submitData = {
      amount: getTopUpItemData.find(opt => {
        return opt.amount.value === selectedPrice;
      }).amount.value,
      gateway_code: Constant.iPay88
    };

    createTopUpRequest && createTopUpRequest(submitData);
  };

  render() {
    const { animationClass, selectedPrice } = this.state;
    const { history, getTopUpItemData } = this.props;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <StyledMainContainer>
          <StyledSelectTopUpValueTitle>
            <FormattedMessage
              id="topup.wallet.select.topup.value.title"
              defaultMessage="1. Select a top-up value (RM)"
              description="Select Top Up Wallet Value Title"
            />
          </StyledSelectTopUpValueTitle>
          <StyledSelectTopUpValueSpan style={{ marginTop: "10px" }}>
            <FormattedMessage
              id="topup.wallet.select.topup.value.span"
              defaultMessage="Select a top-up value to pay through the online payment gateway"
              description="Select Top Up Wallet Value Span"
            />
          </StyledSelectTopUpValueSpan>
          <StyledSelectTopUpContainer>
            {getTopUpItemData &&
              getTopUpItemData.map(items => {
                return (
                  <StyledSelectTopUpValueItem
                    key={items}
                    onClick={() =>
                      this.onValueItemClicked &&
                      this.onValueItemClicked(items.amount.value)
                    }
                    className={
                      selectedPrice !== null &&
                      items.amount.value === selectedPrice
                        ? "active-top-up-value"
                        : ""
                    }
                  >
                    {items.amount.text}
                  </StyledSelectTopUpValueItem>
                );
              })}
          </StyledSelectTopUpContainer>
          {selectedPrice !== null
            ? getTopUpItemData
                .find(opt => {
                  return opt.amount.value === selectedPrice;
                })
                .summary.items.map(msg => {
                  return (
                    <StyledTopUpSummaryContainer key={msg}>
                      <span>{msg.name}</span>
                      <span>{msg.text}</span>
                    </StyledTopUpSummaryContainer>
                  );
                })
            : false}
          {selectedPrice !== null ? (
            <div style={{ width: "100%" }}>
              <StyledLine />
              <StyledTopUpSummaryContainer>
                <span>
                  <FormattedMessage id="topup.wallet.summary.title" />
                </span>
                <span>
                  {
                    getTopUpItemData.find(opt => {
                      return opt.amount.value === selectedPrice;
                    }).payment.total.text
                  }
                </span>
              </StyledTopUpSummaryContainer>
            </div>
          ) : (
            false
          )}
          <StyledTopUpBtn
            className={this.isValid() ? "opacity" : ""}
            disabled={!this.isValid()}
            onClick={() => this.isValid() && this.onPressTopUp()}
          >
            <FormattedMessage
              id="topup.wallet.topup.button.title"
              defaultMessage="Top Up Now"
              description="Select Top Up Button Title"
            />
          </StyledTopUpBtn>
          <StyledTopUpMethodTwo>
            <FormattedMessage
              id="topup.wallet.method.two"
              defaultMessage="2. Top Up Method Two"
              description="Top Up Method Two"
            />
          </StyledTopUpMethodTwo>
          <StyledMethodTwoDescription style={{ marginTop: "10px" }}>
            <FormattedMessage
              id="topup.wallet.method.two.description"
              defaultMessage="You can Top Up your e-wallet at the cashier counter"
              description="You can Top Up your e-wallet at the cashier counter"
            />
          </StyledMethodTwoDescription>
          <StyledQrCode onClick={() => history.push("/shop/self/qr-code")}>
            <FormattedMessage
              id="topup.wallet.method.two.qr.button"
              defaultMessage="Display QR Code For Cashier."
              description="Display QR Code For Cashier."
            />
          </StyledQrCode>
        </StyledMainContainer>
      </StyledContainer>
    );
  }
}

TopUpWalletPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  topUploading: PropTypes.bool,
  topUpStatus: PropTypes.bool,
  updateTopUpPaymentStatus: PropTypes.bool,
  topUpCreatePaymentItem: PropTypes.object,
  createTopUpRequest: PropTypes.func,
  refreshWalletDetailCache: PropTypes.func,
  updateTopUpPayment: PropTypes.func,
  getTopUpItemData: PropTypes.object
};

function mapStateToProps(state) {
  return {
    topUploading: selectors.getWalletTopUpLoading(state),
    topUpStatus: selectors.getWalletTopUpStatus(state),
    updateTopUpPaymentStatus: selectors.getWalletUpdateTopUpPaymentStatus(
      state
    ),
    topUpCreatePaymentItem: selectors.getWalletTopUpCreatePaymentItem(state),
    getTopUpItemData: selectors.getTopUpItemData(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createTopUpRequest: topUpData =>
      dispatch(walletAction.createNewTopUpRequest(topUpData)),
    refreshWalletDetailCache: () =>
      dispatch(walletAction.refreshWalletDetailCacheRequest()),
    updateTopUpPayment: (paymentID, data) =>
      dispatch(walletAction.updateTopUpPaymentRequest(paymentID, data))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopUpWalletPage);



// WEBPACK FOOTER //
// ./src/containers/TopUpWalletPage/index.js